import videoCameraTypes from "./defaults/videoCameraTypes";
import navigatorPermissionList from "./defaults/navigatorPermissionList";

const requiredPermissions = [
  navigatorPermissionList.CAMERA,
  navigatorPermissionList.MICROPHONE,
];

const requiredPermissionsConfig = {
  audio: true,
  video: {
    facingMode: videoCameraTypes.FRONT,
    // width: { min: 1024, ideal: 1280, max: 1920 },
    width: { ideal: 1280 },
    // height: { min: 576, ideal: 720, max: 1080 },
    height: { ideal: 720 },
  },
};

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export { requiredPermissions, requiredPermissionsConfig, API_BASE_URL };
